<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update Core Field</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full" v-if="user_role=='Global Administrator'">
              <vs-input
                class="w-full"
                name="name"
                v-model="coreFieldDescription.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
               <div class="vx-col sm:w-1/3 w-full" v-else>
              <vs-input disabled
                class="w-full"
                name="name"
                v-model="coreFieldDescription.name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="description"
                v-model="coreFieldDescription.description"
                v-validate="'required'"
                data-vv-as="Fields Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Level:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-radio
                v-model="coreFieldDescription.level"
                :vs-value="'account'"
                class="mr-4"
                vs-name="level"
                >Account</vs-radio
              >
              <vs-radio
                v-model="coreFieldDescription.level"
                :vs-value="'contact'"
                class="mr-4"
                vs-name="contact"
                >Contact</vs-radio
              >
            </div>
           
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Identifier:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="name"
                name="identifier"
                :options="identifiers"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="coreFieldDescription.identifier"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
            <span class="text-danger text-sm mt-2">{{
              please_choose_options
            }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Type:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                label="name"
                name="type"
                :options="types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="coreFieldDescription.type"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
            <span class="text-danger text-sm mt-2">{{
              please_choose_options
            }}</span>
          </div>
          <div
            class="vx-row mb-6"
            v-if="
              coreFieldDescription.type == 'dropdown' ||
                coreFieldDescription.type.value == 'dropdown' ||
                coreFieldDescription.type == 'checkbox' ||
                coreFieldDescription.type.value == 'checkbox' ||
                coreFieldDescription.type == 'choose_one' ||
                coreFieldDescription.type.value == 'choose_one'
            "
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Choose Existing List:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-checkbox v-model="chooseExistingList"></vs-checkbox>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('type')"
              >{{ errors.first("type") }}</span
            >
          </div>

          <div
            class="vx-row mb-6"
            v-if="
              coreFieldDescription.type == 'dropdown' ||
                coreFieldDescription.type.value == 'dropdown' ||
                coreFieldDescription.type == 'checkbox' ||
                coreFieldDescription.type.value == 'checkbox' ||
                coreFieldDescription.type == 'choose_one' ||
                coreFieldDescription.type.value == 'choose_one'
            "
          >
            <div class="vx-col sm:w-1/5 w-full">
              <span>Value:</span>
            </div>

            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
                class="w-full"
                name="email"
                v-model="coreFieldDescription.value"
                data-vv-as="Value"
              />
            </div>

            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addValue" color="primary" type="filled"
                >Add</vs-button
              >
            </div>
          </div>
          <div class="vx-row mb-6" v-if="chooseExistingList">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Existing List:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-row vs-w="12" class="mb-5">
                <vs-col vs-lg="8" vs-sm="8" vs-xs="12"
                  >
                   <FieldsAutocomplete
                    :key="companySearchComponentKey"
                    class="searchbox"
                    :list="searchExistingFieldLists"
                    :searchOn="'core-field'"
                    @event-name="handleChildEvent"
                  ></FieldsAutocomplete>
                  <!-- <v-select
                    class="mb-4"
                    label="name"
                    name="existing_list"
                    :options="existing_fields_list"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="fields.existing_list"
                  /> -->
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="4"
                  vs-sm="4"
                  vs-xs="12"
                >
                </vs-col>
              </vs-row>

              <div class="vx-col sm:w-1/2 w-full">
                <span v-for="elv in existing_list_values" class="p-2">
                  <vs-input
                    class="w-full"
                    name="existing_list_value"
                    v-model="elv.value"
                  />
                  <vs-icon
                    class="removeButtonClass"
                    @click="removeExistingListValues(elv)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </span>
              </div>
            </div>
          </div>

          <div
            class="vx-row mb-6"
            v-if="
              coreFieldDescription.type == 'dropdown' ||
                coreFieldDescription.type.value == 'dropdown' ||
                coreFieldDescription.type == 'checkbox' ||
                coreFieldDescription.type.value == 'checkbox' ||
                coreFieldDescription.type == 'choose_one' ||
                coreFieldDescription.type.value == 'choose_one'
            "
          >
            <template>
              <div class="vx-col sm:w-1/5 w-full"></div>
            </template>

            <div
              class="vx-col sm:w-1/4 w-full"
              v-if="coreFieldDescription.values"
            >
              <template v-for="(v, index) in coreFieldDescription.values">
                <span :key="index" class="p-2">
                  <vs-input
                    class="w-full"
                    name="field_new_values"
                    v-model="v.value"
                  />
                  <vs-icon
                    class="removeButtonClass"
                    @click="removeSelectedValue(v)"
                    color="success"
                    icon="clear"
                  ></vs-icon>
                </span>
              </template>
            </div>
          </div>

          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="updateForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <DataGrid :context="'coreFields'" 
            ref="coreFields"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import FieldsAutocomplete from "@/components/autocomplete/FieldsAutocomplete.vue";
import moduleCoreFieldsManagement from "@/store/fields-management/core-fields-management/moduleCoreFieldsManagement.js";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      user_role : null,
      companySearchComponentKey: 0,
      please_choose_options: null,
      coreFieldDescription: [],
      fieldId: null,
      chooseExistingList: false,
      identifiers: [
        {
          value: "company_name",
          name: "company_name",
        },
        {
          value: "actual_account_name",
          name: "actual_account_name",
        },
        {
          value: "registered_office_address_1",
          name: "registered_office_address_1",
        },
        {
          value: "registered_office_address_2",
          name: "registered_office_address_2",
        },
        {
          value: "registered_office_address_3",
          name: "registered_office_address_3",
        },
        {
          value: "registered_office_city",
          name: "registered_office_city",
        },
        {
          value: "registered_office_county",
          name: "registered_office_county",
        },
        {
          value: "registered_office_postcode",
          name: "registered_office_postcode",
        },
        {
          value: "registered_office_country",
          name: "registered_office_country",
        },
        {
          value: "head_office_address_1",
          name: "head_office_address_1",
        },
        {
          value: "head_office_address_2",
          name: "head_office_address_2",
        },
        {
          value: "head_office_address_3",
          name: "head_office_address_3",
        },
        {
          value: "head_office_city",
          name: "head_office_city",
        },
        {
          value: "head_office_county",
          name: "head_office_county",
        },
        {
          value: "head_office_postcode",
          name: "head_office_postcode",
        },
        {
          value: "head_office_country",
          name: "head_office_country",
        },
        {
          value: "satellite_office_address_1",
          name: "satellite_office_address_1",
        },
        {
          value: "satellite_office_address_2",
          name: "satellite_office_address_2",
        },
        {
          value: "satellite_office_address_3",
          name: "satellite_office_address_3",
        },
        {
          value: "satellite_office_city",
          name: "satellite_office_city",
        },
        {
          value: "satellite_office_county",
          name: "satellite_office_county",
        },
        {
          value: "satellite_office_postcode",
          name: "satellite_office_postcode",
        },
        {
          value: "satellite_office_country",
          name: "satellite_office_country",
        },
        {
          value: "company_registration_number",
          name: "company_registration_number",
        },
        {
          value: "company_category",
          name: "company_category",
        },
        {
          value: "registration_jurisdiction",
          name: "registration_jurisdiction",
        },
        {
          value: "revenue",
          name: "revenue",
        },
        {
          value: "no_of_employees",
          name: "no_of_employees",
        },
        {
          value: "parent",
          name: "parent",
        },
        {
          value: "vertical",
          name: "vertical",
        },
        {
          value: "currency_code",
          name: "currency_code"
        },
        {
          value: "sic_code",
          name: "sic_code",
        },
        {
          value: "status",
          name: "status",
        },
        {
          value: "website",
          name: "website",
        },
        {
          value: "linkedin",
          name: "linkedin",
        }
        ,
        {
          value: "switchboard_phone_code",
          name: "switchboard_phone_code",
        },
        {
          value: "switchboard",
          name: "switchboard",
        },
        {
          value: "site_switchboard_phone_code",
          name: "site_switchboard_phone_code",
        },
        {
          value: "site_switchboard",
          name: "site_switchboard",
        },
        {
          value: "phone",
          name: "phone",
        },
        {
          value: "phone_code",
          name: "phone_code",
        },
        {
          value: "title",
          name: "title",
        },
        {
          value: "forename",
          name: "forename",
        },
        {
          value: "surname",
          name: "surname",
        },
        {
          value: "job_title",
          name: "job_title"
        },
        {
          value: "email",
          name: "email"
        },
        {
          value: "ddi_phone_code",
          name: "ddi_phone_code"
        },
        {
          value: "ddi",
          name: "ddi"
        },
        {
          value: "mobile_phone_code",
          name: "mobile_phone_code"
        },
        {
          value: "mobile",
          name: "mobile"
        },
        {
          value: "social_media",
          name: "social_media"
        },
        {
          value: "contact_social_media",
          name: "contact_social_media"
        },
        {
          value: "role",
          name: "role"
        },
        {
          value: "sub_role",
          name: "sub_role"
        },
        {
          value: "seniority",
          name: "seniority"
        },
        {
          value: "contact_social_media_summary",
          name: "contact_social_media_summary"
        }
     

 
  
      ],
      columnDefs: [
        {
          headerName: "Name",
          field: "name",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

          headerName: "Description",
          field: "description",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

        headerName: "Level",
        field: "level",
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
          flex: 1,
          headerName: "Identifier",
          field: "identifier",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

          headerName: "Type",
          field: "type",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Value",
          field: "values",
          width: 550,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
    
      ],
      dataSource: {},
      records: [],
      selected: [],
      allFields: [],
      abilities: null,
      existing_list_values: null,
      existing_fields_list: [],
      fields: {
        values: [],
        name: null,
        description: null,
        level:'account',
        type: null,
        value: null,
        existing_list: null
      },
      types: [
        {
          name: "Text",
          value: "text"
        },
        {
          name: "Number",
          value: "number"
        },
        {
          name: "Textarea",
          value: "textarea"
        },
        {
          name: "Date",
          value: "date"
        },
        {
          name: "DateTime",
          value: "datetime"
        },
        {
          name: "Checkbox",
          value: "checkbox"
        },
        {
          name: "Dropdown",
          value: "dropdown"
        },
        {
          name: "Choose One",
          value: "choose_one"
        },
        {
          name: "Client Contact",
          value: "client_contact"
        }
      ]
    };
  },
  components: {
    "v-select": vSelect,
    moduleCoreFieldsManagement,
    DataGrid,
    FieldsAutocomplete
  },
  created() {
    var self = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_role = userInfo["userRole"];
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCoreFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "CoreFieldsManagement",
        moduleCoreFieldsManagement
      );
      moduleCoreFieldsManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fieldId = this.$route.params.fieldId;
    this.fetchCoreField();
    this.getExistingFieldLists();
  },
  watch: {
    "coreFieldDescription.type.value": function(val) {
      if (val) {
        this.please_choose_options = null;
      }
    },
    // "fields.existing_list": function(val) {
    //   if (val) {
    //     let filtered_value = this.existing_fields_list.filter(ele => {
    //       return ele.field_id == val.field_id;
    //     });
    //     if (filtered_value) {
    //       let lists = filtered_value[0];
    //       this.existing_list_values = JSON.parse(lists.values);
    //     }

    //     console.log(this.existing_list_values);
    //   }
    // },
    chooseExistingList: function(val) {
      if (val) {
        this.chooseExistingList = true;
        // this.existing_list_values = null
        // // let filtered_value = this.existing_fields_list.filter(ele => {
        // //   return ele.field_id == val.field_id;
        // // });
        // let filtered_value = this.existing_fields_list
        // if (filtered_value) {
        //   let lists = filtered_value[0];
        //   this.existing_list_values = JSON.parse(lists.values);
        // }

        // console.log(this.existing_list_values);
      } else {
        this.existing_list_values = [];
      }
    },
    "coreFieldDescription.type": function(val) {
      // if(this.coreFieldDescription.type == val){
      //   this.coreFieldDescription.type.value == val
      // }
      // alert(val)
    }
  },
  methods: {
      searchExistingFieldLists(inputValue) {
      let search_from = "core_field";
      return this.$store
        .dispatch("CoreFieldsManagement/searchExistingFieldLists", {
          search_from: search_from,
          inputValue: inputValue
        })
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              data = JSON.parse(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].field_id,
                  name: data[property].name
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    handleChildEvent() {
      let selected_field = moduleCoreFieldsManagement.state.selected_fields;
      if (selected_field) {
        let filtered_value = this.existing_fields_list.filter(ele => {
          return ele.field_id == selected_field.id;
        });
        if (filtered_value) {
          let lists = filtered_value[0];
          this.existing_list_values = JSON.parse(lists.values);
        }

        console.log(this.existing_list_values);
      }
    },
    removeSelectedValue(value) {
      this.coreFieldDescription.values = this.coreFieldDescription.values.filter(
        item => {
          return item != value;
        }
      );
    },
    removeExistingListValues(value) {
      this.existing_list_values = this.existing_list_values.filter(item => {
        return item != value;
      });
    },
    addValue() {
      if (this.coreFieldDescription.values == null) {
        this.coreFieldDescription.values = [];
      }

      if (
        this.coreFieldDescription.value &&
        !this.coreFieldDescription.values.includes(
          this.coreFieldDescription.value
        )
      )
        this.coreFieldDescription.values.push({
          value: this.coreFieldDescription.value
        });
      this.coreFieldDescription.value = null;
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "CoreFieldsManagement/getAllCoreFields",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.coreFields.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.coreFields.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    updateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateFields();
        }
      });
    },
    updateFields() {
      if (this.coreFieldDescription.values == null) {
        this.coreFieldDescription.values = [];
      }

      if (this.existing_list_values == null) {
        this.existing_list_values = [];
      }

      if (
        this.coreFieldDescription.type.value == "checkbox" ||
        this.coreFieldDescription.type == "checkbox" ||
        this.coreFieldDescription.type.value == "dropdown" ||
        this.coreFieldDescription.type == "dropdown" ||
        this.coreFieldDescription.type.value == "choose_one" ||
        this.coreFieldDescription.type == "choose_one"
      ) {
        if (
          this.coreFieldDescription.values.length == 0 &&
          this.existing_list_values.length == 0
        ) {
          this.please_choose_options =
            "Atleast one options is required for " +
            this.coreFieldDescription.type.value +
            " list.";
          return false;
        }
      }

      let joined_values = [];
      joined_values = this.coreFieldDescription.values.concat(
        this.existing_list_values
      );
      joined_values = joined_values.filter(function(ele) {
        return ele != null;
      });
      this.coreFieldDescription.values = joined_values;

      if (typeof this.coreFieldDescription.type === "object") {
        this.coreFieldDescription.type = this.coreFieldDescription.type.value;
      }

      if (typeof this.coreFieldDescription.identifier === "object") {
        this.coreFieldDescription.identifier = this.coreFieldDescription.identifier.value;
      }

      if (
        this.coreFieldDescription.type == "text" ||
        this.coreFieldDescription.type == "number" ||
        this.coreFieldDescription.type == "textarea" ||
        this.coreFieldDescription.type == "date"
      ) {
        this.coreFieldDescription.values = null;
      }

      this.$store
        .dispatch(
          "CoreFieldsManagement/updateFields",
          this.coreFieldDescription
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Core Fields Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Fields Added",
              text: "The core fields was updated successfully"
            });
            this.$router.push({ path: "/fields/core-fields" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchCoreField() {
      this.$store
        .dispatch("CoreFieldsManagement/fetchFields", this.fieldId)
        .then(res => {
          let result = JSON.parse(res.data);
          this.coreFieldDescription = result[0];
      

          this.coreFieldDescription.values = JSON.parse(
            this.coreFieldDescription.values
          );
        })
        .catch(err => {
          console.error(err);
        });
    },
    getExistingFieldLists() {
      this.$store
        .dispatch(
          "CoreFieldsManagement/getExistingFieldLists",
          "core_field"
        )
        .then(res => {
          console.log("LISTS", JSON.parse(res.data));
          let result = JSON.parse(res.data);
          if (result) {
            this.existing_fields_list = result;
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
